import styled from "styled-components";
import { useContext } from "react";
import { Context } from "../../../context";

export const WhyWorkPlacePayWrapper = styled("div")(() => {
  const { isMenuOpen } = useContext(Context);
  return {
    position: "relative",
    top: isMenuOpen ? "var(--mobileNavLinks)" : "0",
    margin: "calc(var(--sectionMargin) * 4) auto",
    padding: "2rem var(--pagePadding)",
    width: "80%",
    minHeight: "70vh",
    display: "grid",
    gridTemplateColumns: "1fr 1fr",
    gap: "calc(var(--flexGap) * 2)",
    alignItems: "flex-start",
    "@media screen and (min-width: 1024px)": {
      margin: "calc(var(--sectionMargin) * 3) auto",
    },
    "@media screen and (max-width: 1024px)": {
      gridTemplateColumns: "1fr",
      gap: "var(--flexGap)",
      margin: "calc(var(--sectionMargin) * 2) auto",
      width: "75%",
    },
    "@media screen and (max-width: 768px)": {
      width: "100%",
    },
  };
});

export const LeftContent = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "var(--flexGap)",
    position: "sticky",
    top: "calc(var(--navHeight) + 2rem)",
    maxHeight: "calc(100vh - var(--navHeight) - 2rem)",
    "& h2": {
      marginBlock: 0,
      color: "var(--color-text)",
    },
    "& > p:first-of-type": {
      marginBlock: 0,
      color: "var(--color-text-light)",
      lineHeight: "1.6",
    },
    "@media screen and (max-width: 1024px)": {
      position: "static",
      top: "auto",
    },
  };
});

export const RightContent = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "var(--flexGap)",
    "& h3": {
      marginBlock: 0,
      color: "var(--color-text)",
      fontSize: "1.75rem",
      lineHeight: "1.3",
    },
    "& > p": {
      marginBlock: 0,
      color: "var(--color-text-light)",
      lineHeight: "1.6",
    },
    "& .features-container": {
      display: "flex",
      flexDirection: "column",
      gap: "calc(var(--flexGap)/1.5)",
    },
  };
});

export const SubheadingContainer = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "calc(var(--flexGap)/2)",
    alignItems: "flex-start",
    padding: "var(--flexGap)",
    backgroundColor: "#FFFFFF",
    borderRadius: "1rem",
    border: "1px solid #EFEFEF",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
  };
});

export const FeatureItem = styled("div")(() => {
  return {
    display: "flex",
    gap: "var(--flexGap)",
    alignItems: "flex-start",
    padding: "calc(var(--flexGap)/1.5)",
    backgroundColor: "#FFFFFF",
    borderRadius: "8px",
    border: "1px solid #EFEFEF",
    transition: "all 0.3s ease",
    "&:hover": {
      boxShadow: "0 4px 12px rgba(0, 0, 0, 0.1)",
    },
  };
});

export const FeatureIcon = styled("div")(() => {
  return {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    minWidth: "48px",
    width: "48px",
    height: "48px",
    borderRadius: "8px",
    backgroundColor: "#D4F0E8",
    color: "var(--color-tertiary)",
    fontSize: "1.25rem",
    flexShrink: 0,
  };
});

export const FeatureText = styled("div")(() => {
  return {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
    "& h4": {
      marginBlock: 0,
      color: "var(--color-text)",
      fontSize: "1rem",
      fontWeight: "600",
    },
    "& p": {
      marginBlock: 0,
      color: "var(--color-text-light)",
      fontSize: "0.9rem",
      lineHeight: "1.5",
    },
  };
});
